/**
 * GraphQL Client Utility
 * Handles GraphQL requests to the WordPress GraphQL API
 */

const WP_API_BASE_URL = process.env.REACT_APP_WP_API_BASE_URL || 'https://localhost:8000';
const GRAPHQL_ENDPOINT = `${WP_API_BASE_URL}/graphql`;

/**
 * Execute a GraphQL query or mutation
 * @param {string} query - GraphQL query/mutation string
 * @param {Object} variables - Variables for the query/mutation
 * @param {string} token - Optional authorization token
 * @returns {Promise<Object>} GraphQL response data
 */
export async function graphqlRequest(query, variables = {}, token = null) {
  const headers = {
    'Content-Type': 'application/json',
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  try {
    const response = await fetch(GRAPHQL_ENDPOINT, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        query,
        variables,
      }),
    });

    const result = await response.json();

    if (result.errors) {
      // GraphQL errors are in result.errors array
      const errorMessage = result.errors[0]?.message || 'GraphQL request failed';
      throw new Error(errorMessage);
    }

    return result.data;
  } catch (error) {
    if (error.message) {
      throw error;
    }
    throw new Error('Network error. Please try again.');
  }
}

